import React from 'react';
import { Stack } from '@hub/stack';
import { incBase } from '../../helpers/paths';
import * as paths from './paths';
import { MembershipColumnLinks } from './membership-column-links';
import useFeatureFlag from '../../hooks/use-feature-flag';
import { FeatureFlagName } from '../../feature-flags';
import { jsx as _jsx } from "react/jsx-runtime";
const LOGIN = incBase('login');
const REGISTER = incBase('register');
const westfieldPlusSection = {
  heading: {
    text: 'Westfield Plus',
    url: paths.WESTFIELD_PLUS,
    newTab: true
  },
  links: [{
    text: 'Login',
    url: LOGIN,
    trackingLabel: 'Westfield Plus Login'
  }, {
    text: 'Join',
    url: REGISTER,
    trackingLabel: 'Westfield Plus Join link'
  }, {
    text: 'Terms and Conditions',
    url: paths.TERMS_CONDITIONS_WESTFIELD_PLUS,
    newTab: false
  }, {
    text: 'Privacy Statement',
    url: paths.PRIVACY_POLICY_WESTFIELD_PLUS,
    newTab: false
  }, {
    text: 'FAQs',
    url: paths.FAQS_WESTFIELD_PLUS,
    newTab: true
  }]
};
const westfieldMembershipSection = {
  heading: {
    text: 'Membership',
    url: paths.WESTFIELD_MEMBERSHIP,
    newTab: true
  },
  links: [{
    text: 'Login',
    url: LOGIN,
    trackingLabel: 'Westfield Plus Login'
  }, {
    text: 'Join',
    url: REGISTER,
    trackingLabel: 'Westfield Plus Join link'
  }, {
    text: 'Terms and Conditions',
    url: paths.TERMS_CONDITIONS_WESTFIELD_MEMBERSHIP,
    newTab: false
  }, {
    text: 'Privacy Statement',
    url: paths.PRIVACY_POLICY_WESTFIELD_MEMBERSHIP,
    newTab: false
  }, {
    text: 'FAQs',
    url: paths.FAQS_WESTFIELD_MEMBERSHIP,
    newTab: true
  }]
};
export const WestfieldPlusContainer = _ref => {
  let {
    country
  } = _ref;
  const enableBrandUpdate = useFeatureFlag(FeatureFlagName.NEXT_PUBLIC_FEAT_FLAG_UPDATED_BRAND);
  return /*#__PURE__*/_jsx(Stack, {
    shouldWrapChildren: false,
    sx: {
      flexGrow: 1,
      marginTop: ['spacing-xl', 0]
    },
    "data-id": "universal-footer_westfield-plus-container_WestfieldPlusContainer_Stack",
    children: country === 'Australia' && /*#__PURE__*/_jsx(MembershipColumnLinks, {
      heading: enableBrandUpdate ? westfieldMembershipSection.heading : westfieldPlusSection.heading,
      links: enableBrandUpdate ? westfieldMembershipSection.links : westfieldPlusSection.links,
      "data-id": "universal-footer_westfield-plus-container_WestfieldPlusContainer_MembershipColumnLinks"
    })
  });
};